import { InjectableClass } from '@fino/lib-injection';

export class TranslateModalController extends InjectableClass {
  constructor(
    $uibModalInstance,
    $translate,
    translateModalService,
    translate,
    customization
  ) {
    'ngInject';
    super({
      $uibModalInstance,
      $translate,
      translateModalService,
      translate,
      customization
    });
  }

  get defaultCustom() {
    return 'fino';
  }

  $onInit() {
    this.model = this.translate || {};
    this.setupCustom();
  }

  setupCustom() {
    this.model.custom = this.customization.custom || this.defaultCustom;
    if (this.customization.customs) {
      const selectables = Object.values(this.customization.customs).map(custom => {
        return {
          key: custom,
          value: custom
        };
      });

      this.customs = {
        modelKey: 'key',
        selectables
      };
    }
  }

  updateTranslation() {
    if (!this.model.key) {
      return;
    }
    const value = this.$translate.instant(this.model.key);
    // When there is no translation defined, the key will be returned
    if (value !== this.model.key) {
      this.model.value = value;
    }
  }

  save() {
    const { $uibModalInstance, model } = this;

    this.loading = true;
    this.translateModalService.save(model)
      .then((result) => {
        if (this.createAnother) {
          this.clear();
        }
        else {
          $uibModalInstance.close(result.data);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  clear() {
    this.model.key = this.model.value = null;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translate/src/modal/translateModal.controller.js